
export const CDN_ROOT = "https://cdn.builtwithscience.com";

const CACHE_BUSTED_IMAGE_VERSIONS: Record<string, string> = {
  "images/new-quiz-bodytype-images-2025/female-bodytype/5.png": "20260305",
  "images/bodyfat/female40.jpg": "20260305",
  "images/new-quiz-bodyfat-images/Female/40.png": "20260305",
};

export function getCdnImageUrl(path: string): string {
  const version = CACHE_BUSTED_IMAGE_VERSIONS[path];
  return `${CDN_ROOT}/${path}${version ? `?v=${version}` : ""}`;
}
